import TopStoriesCard from "./top-stories-card";
import TopStoriesSwiper from "./top-stories-swiper";

export default { TopStoriesCard, TopStoriesSwiper };
